export default __webpack_public_path__ + "static/media/iphone-xs-max.adfef2fd.jpg";